import { combineReducers } from 'redux-immutable';
import { reducer as notifReducer } from 'redux-notifications';
import { routerReducer } from '../utils/reducers/routerReducer';
import { section } from './Dictionaries/reducer';
import user from './User/reducer';
import favorites from './Favorites/reducer';
import tariffs from './Tariffs/reducer';
import savedSearch from './SavedSearch/reducer';
import search from './Search/reducer';
import announcement from './CardAnnouncement/reducer';
import auth from './Auth/reducer';
import comments from './Comments/reducer';
import claims from './Claims/reducer';
import maps from './Maps/reducer';
import home from './Home/reducer';

const dumbReducer = (state = {}) => state;

const rootReducer = combineReducers({
  domain: dumbReducer,
  dictionaries: dumbReducer,
  section,
  user,
  auth,
  comments,
  claims,
  favorites,
  search,
  maps,
  home,
  announcement,
  savedSearch,
  routing: routerReducer,
  notifs: notifReducer,
  tariffs
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/reducers.js